interface AppInfo {
  name: string;
  version: string;
}

let appInfo: AppInfo | null = null;

export const setAppInfo = (name: string, version: string) => {
  appInfo = { name, version };
};

export const getAppInfo = (): AppInfo | null => {
  if (appInfo) {
    return appInfo;
  }

  const hubspot = window.hubspot as any;
  return hubspot && hubspot.bender
    ? {
        name: hubspot.bender.currentProject,
        version: hubspot.bender.currentProjectVersion,
      }
    : null;
};
